/**
 * @author Ariel
 * @desc 活动表单页面
 * @date 2020-09-16
 */
import React from "react";
import {connect} from "dva";
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {WizAuthority} from '../../../common'
import { formatAuth } from '@/utils/commonUtils'
import moment from "moment";

let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils,} = framework_tool
let {WizCard, WizSpin, WizForm, Wizmessage, WizRow, WizCol, WizAutoComplete, WizInput,WizModal} = component_tool
let {Session} = utils_tool

class ActivityDetail extends WizContainer {
  componentName = 'activityDetail'

  constructor(props) {
    super(props)
    const {history} = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/interact/activity/activityDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('activityInfo', initialValue)
      } else {
        initialValue = Session.get('activityInfo') || {}
      }
      cardTitle = '编辑'
    }
    this.initialValue = initialValue
    this.state = {
      cardTitle,
    }
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      this.doAction({
        path: 'activity/look',
        payload: {
          key: 'activityInfo',
          apiParams: {id: this.initialValue.id}
        }
      })
    }
  }

  propsAndStateOnChange = {
    addActivity: this._addActivityOver.bind(this)
  }

  _addActivityOver(nextProps, nextState) {
    if (nextProps.addActivity.code == 1) {
      
      wizNotice.success('保存成功');
      let bizId =nextProps.addActivity.data
       
      if(bizId){
        if(bizId>0){

          WizModal.confirm({
            title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
            onOk: () => {
              this.doAction({
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: bizId,
                    bizType: 23,
                    resend:true
                  },
                },
              })
              this.jumpPage('replace', '/interact/activity');
            },
            onCancel: () => {
              this.doAction({
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: bizId,
                    bizType: 23,
                    resend:false
                  },
                },
              })
              this.jumpPage('replace', '/interact/activity');
            },
          });
        }else{

          this.doAction({
            path:  "notice/sendNotice",
            payload: {
              key: "sendNoticeKey",
              apiParams: {
                bizId: 0-bizId,
                bizType: 23,
                resend:false
              },
            },
          })
          this.jumpPage('replace', '/interact/activity');
        }
    }

    this.jumpPage('replace', '/interact/activity');
    } else {
      wizNotice.error('提交失败：' + nextProps.addActivity.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'activityTime' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD HH:mm:00")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD HH:mm:00")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let remark = fitterValues['remark']
    if (remark && remark.length) {
      fitterValues['remarkImg'] = remark[0]['fileId']
      delete fitterValues['remark']
    }
    let background = fitterValues['background']
    if (background && background.length) {
      fitterValues['backgroundImg'] = background[0]['fileId']
      delete fitterValues['background']
    }
    let detail = fitterValues['detail']
    if (detail && detail.length) {
      fitterValues['detailImg'] = detail[0]['fileId']
      delete fitterValues['detail']
    }
    let recommend = fitterValues['recommend']
    if (recommend && recommend.length) {
      fitterValues['recommendImg'] = recommend[0]['fileId']
      delete fitterValues['recommend']
    }
    let share = fitterValues['share']
    if (share && share.length) {
      fitterValues['shareImg'] = share[0]['fileId']
      delete fitterValues['share']
    }
    /**
     * 权限参数处理
     */
    // let authCmd = {}
    // if (fitterValues['authCmd']) {
    //   let authInfo = fitterValues['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // fitterValues['authCmd'] = authCmd

    fitterValues['authCmd'] = formatAuth(fitterValues['authCmd'])
    
    return fitterValues;
  }

  _addActivity(values) {
    const {history} = this.props
    let apiPath = 'activity/add';
    if (history.location && history.location.pathname === '/interact/activity/activityDetailUpd') {
      apiPath = 'activity/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addActivity',
        apiParams: {...fitterValues}
      }
    })
  }

  _render() {
    const {activityLoading, activityInfo} = this.props
    const {cardTitle} = this.state
    let initialValue = this.initialValue
    let dateFormat = "YYYY-MM-DD HH:mm"

    if (activityInfo && activityInfo.success) {
      initialValue = activityInfo.data
    }

    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.id
        }
      },
      {
        title: '活动名称',
        name: 'name',
        formItem: {
          maxLength: 18,
          placeholder: '活动名称最多输入18个字',
          initialValue: initialValue.name,
          rules: [
            {
              required: true,
              message: '请输入活动名称'
            }
          ],
        }
      },
      {
        title: '活动时间',
        name: 'activityTime',
        formItem: {
          type: 'date~',
          rules: [
            {
              required: true,
              message: '请选择活动时间'
            }
          ],
          showTime: true,
          format: 'YYYY-MM-DD HH:mm',
          initialValue: initialValue.startTime ? [moment(initialValue.startTime, dateFormat), moment(initialValue.endTime, dateFormat)] : null
        }
      },
      {
        title: '主办方',
        name: 'sponsor',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <WizRow>
                <WizCol>
                  {getFieldDecorator('sponsor', {
                    maxLength: 20,
                    placeholder: '主办方最多输入20个字',
                    rules: [
                      {
                        required: true,
                        message: '请输入主办方'
                      },
                      {
                        pattern: /^[\u4e00-\u9fa5_a-zA-Z· ]+$/,
                        message: '主办方只能包含中文、英文、·、空格'
                      }
                    ],
                    initialValue: initialValue.sponsor,
                  })(
                    <WizAutoComplete
                      dataSource={['别克', '雪佛兰', '凯迪拉克', '上海慧龙', '总部']}
                      children={<WizInput/>}
                      filterOption={true}
                    />
                  )}
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '活动受众',
        name: 'authCmd',
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          initialValue: initialValue.authInfo,
          record: {
            authCmd: initialValue.authInfo && initialValue.authInfo
          },
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
          rules: [
            {
              required: true,
              message: '请选择活动受众'
            },
          ]
        }
      },
      {
        title: '是否需要报名',
        name: 'apply',
        formItem: {
          // initialValue: initialValue.apply != null ? initialValue.apply : 0,
          // type: 'radio',
          // dict: [
          //   {code: 1, codeName: '是'},
          //   {code: 0, codeName: '否'},
          // ],
          // rules: [
          //   {
          //     required: true,
          //     message: '请选择是否需要报名'
          //   }
          // ]
          initialValue: 0,
          type: "hidden"
        }
      },
      {
        title: '简介图片',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('remark', {
                  rules: [{required: true, message: '简介图片不能为空'}],
                  initialValue: (initialValue && initialValue.remarkImg) ? [
                    {fileId:initialValue.remarkImg}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={500 / 1000}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.292;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过300k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '背景图片',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('background', {
                  rules: [{required: true, message: '背景图片不能为空'}],
                  initialValue: (initialValue && initialValue.backgroundImg) ? [
                    {fileId:initialValue.backgroundImg}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={500 / 450}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.195;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过200k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '详情图片',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('detail', {
                  rules: [{required: true, message: '详情图片不能为空'}],
                  initialValue: (initialValue && initialValue.detailImg) ? [
                   {fileId:initialValue.detailImg}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={500 / 800}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.292;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过300k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '展示图片',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('recommend', {
                  rules: [{required: true, message: '展示图片不能为空'}],
                  initialValue: (initialValue && initialValue.recommendImg) ? [
                    {fileId:initialValue.recommendImg}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={500 / 140}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.097;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过100k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '分享图',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('share', {
                  rules: [{required: true, message: '分享图不能为空'}],
                  initialValue: (initialValue && initialValue.shareImg) ? [
                    {fileId:initialValue.shareImg}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={600 / 310}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.097;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过100k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '状态',
        name: 'state',
        formItem: {
          initialValue: initialValue.state != null ? initialValue.state : 1,
          type: 'radio'
        },
        dict: [
          {code: 1, codeName: '打开'},
          {code: 0, codeName: '关闭'}
        ]
      },
    ]

    let onSubmit = this._addActivity.bind(this)

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={activityLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {activity} = state;
  const addActivity = modelUtils.getModelEntity(activity, 'addActivity');
  const activityInfo = modelUtils.getModelEntity(activity, 'activityInfo');
  const load = modelUtils.getLoadingState(state, 'activity');
  return {
    addActivity,
    activityInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ActivityDetail);

